import React from 'react'
import { iconMap } from '@mortgage-pos/ui/utils/customizationHelpers'

const CardsValueProps = () => {
  return (
    <div className="br-cards-vp__container">
      <h1 className="br-cards-vp__heading">
        The fastest, most complete way to get a personalized mortgage
      </h1>
      <div className="br-cards-vp__bg-container">
        <div className="br-cards-vp__cards-container">
          <div className="br-cards-vp__card-container">
            <img
              src={iconMap('valuePropClock')}
              alt="Clock Icon"
              className="br-cards-vp__card-image"
            />
            <h2 className="br-cards-vp__card-heading">15 seconds</h2>
            <p className="br-cards-vp__card-description">
              See your personalized top options, fast
            </p>
          </div>
          <div className="br-cards-vp__card-container">
            <img
              src={iconMap('valuePropHouse')}
              alt="House Icon"
              className="br-cards-vp__card-image"
            />
            <h2 className="br-cards-vp__card-heading">300,000+ comparisons</h2>
            <p className="br-cards-vp__card-description">
              We’ll match you with the right ones
            </p>
          </div>
          <div className="br-cards-vp__card-container">
            <img
              src={iconMap('valuePropReviews')}
              alt="Reviews Icon"
              className="br-cards-vp__card-image"
            />
            <h2 className="br-cards-vp__card-heading">100% online</h2>
            <p className="br-cards-vp__card-description">
              Get custom offers without talking to an agent
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardsValueProps
